import React from 'react';
import { Input, Form, Button, Card, Icon } from 'antd';
import { FormComponentProps } from 'antd/lib/form/Form';
import { locksConfig } from './lockConfigs';

type MainPageProps = {
  setSelectedLock: (selectedLock: number) => void;
} & FormComponentProps;

const MainPage = (props: MainPageProps): any => {
  const { getFieldDecorator } = props.form;

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        props.setSelectedLock(+values.lock);
      }
    });
  };

  return (
    <>
      <Card>
        <h1 className="escapeRoomHeader">THE BOX IN THE ATTIC</h1>
        <h3>Type in the CARD NUMBER with the <Icon type="lock" theme="filled" /> below:</h3>
        <Form onSubmit={onSubmit}>
          <Form.Item>
            {getFieldDecorator('lock', {
              rules: [{
                required: true, message: 'Please input a number!', whitespace: true
              }, {
                validator: (rule: string, value: string, callback: (err?: string) => void) => {
                  if (!locksConfig.find(lock => lock.code === +value)) {
                    callback(`${value} is not a valid lock number`);
                  } else {
                    callback();
                  }
                }
              }
              ]
            })(<Input data-cy="lock-input" size="large" prefix={<Icon type="lock" theme="filled" />} />)}
          </Form.Item>

          <Button data-cy="main-submit" type="primary" htmlType="submit">
            Submit
          </Button>
        </Form>
      </Card>
    </>
  );
};

export default Form.create<MainPageProps>({ name: 'main' })(MainPage);
